import "./scss/GLSDk.scss";
import "./css/leaflet.css";

import WooCommerce from "./js/GLSDk-woo-commerce.js";
import GLSDkWidget from "./js/GLSDk-widget";

/**
 * Class GLSDk depends on jQuery.
 * Check if we are meant to append a map
 *
 * Platform dependent functions marked with   * @platformDependent
 */
class GLSDk {
  constructor(ajax_url) {
    console.log("GLSDK CONSTRUCT");
    this.markers = []; //pickup {lat, lng}
    this.isMapLoaded = false;
    this.gmaps_key =
      typeof GLSDk_maps_key == "undefined" ? "" : GLSDk_maps_key;
    this.openMapMarkerIcons = {};
    this.ajax_url = ajax_url; // platform dependent

    // ✅ Track if scripts are preloading
    this.scriptsPreloaded = false;
    this.addressPreGeocoded = false;

    this.platform = new WooCommerce(this.ajax_url);

    this.platform.isCheckout();
    this.init();
  }

  init() {
    console.log("Entered init");
    this.GLSDkWidget = new GLSDkWidget({
      host: "https://GLSDk.me",
      address: this.platform.getShippingData().Address,
      labels: {},
      mapParentContainer: "body",
      buttonParentContainer: "body",
      buttonClass: "",
      ajax_url: this.ajax_url,
      carrierId: this.platform.getShippingData().CarrierId,
      onPointSelected: () => {},
      gmapskey:
        typeof GLSDk_maps_key == "undefined" ? "" : GLSDk_maps_key,
    });
    this.GLSDkWidget.init();

    // ✅ Preload map resources in the background
    this.preloadMapResources();

    console.log("Finished init");
  }

  /**
   * ✅ NEW: Preload map scripts and geocode address in background
   */
  preloadMapResources() {
    console.log("🚀 Preloading map resources...");

    setTimeout(() => {
      // ✅ 1. Preload map scripts
      if (this.GLSDkWidget.mapinterface && !this.scriptsPreloaded) {
        console.log("📦 Preloading map scripts");
        this.scriptsPreloaded = true;

        if (jQuery("#sw").length === 0) {
          this.GLSDkWidget.addMapHtml();
        }
      }

      // ❌ DISABLE ADDRESS PRE-GEOCODING - causes rate limit issues
      // Only geocode when user actually opens the map
      /*
    if (!this.addressPreGeocoded && this.GLSDkWidget.options.address) {
      const address = this.GLSDkWidget.options.address;

      if (address.City && address.Country) {
        console.log("🌍 Pre-geocoding address:", address.City, address.Country);
        this.addressPreGeocoded = true;

        this.GLSDkWidget.geocodeAddress(address, (geo) => {
          if (geo && geo.length && geo[0].lat) {
            console.log("✅ Address pre-geocoded:", geo[0].lat, geo[0].lng);
            this.GLSDkWidget.options.address.Lat = geo[0].lat;
            this.GLSDkWidget.options.address.Long = geo[0].lng;
            this.preFetchPickupPoints();
          }
        });
      }
    }
    */
    }, 2000);
  }
  /**
   * ✅ NEW: Pre-fetch pickup points in background
   */
  preFetchPickupPoints() {
    // Only if we have carrier ID and geocoded address
    if (
      !this.GLSDkWidget.carrier_id ||
      !this.GLSDkWidget.options.address.Lat
    ) {
      console.log("⏭️ Skipping pre-fetch - missing carrier or coordinates");
      return;
    }

    console.log("📍 Pre-fetching pickup points...");

    const req = {
      Address: this.GLSDkWidget.options.address,
      CarrierId: this.GLSDkWidget.carrier_id,
      action: "GLSDk_pickup_locations",
    };

    jQuery
      .getJSON(this.ajax_url, req, (data) => {
        if (data && data.Point && data.Point.length > 0) {
          console.log("✅ Pickup points pre-fetched:", data.Point.length);

          // ✅ Cache the results
          const cacheKey = this.GLSDkWidget.hashLatLng({
            lat: this.GLSDkWidget.options.address.Lat,
            lng: this.GLSDkWidget.options.address.Long,
          });

          this.GLSDkWidget.cacheResults[cacheKey] = data;
          console.log("💾 Cached pickup points for instant display");
        }
      })
      .fail(() => {
        console.log("⚠️ Pre-fetch failed (not critical)");
      });
  }

  getPickupLocations(evt) {
    console.log("Choose Pickup Location");

    // ✅ Show loader immediately (no delay)
    const loaderHtml = `
        <div class="GLSDk-loader-btn" style="position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; background-color: rgba(0, 0, 0, 0.7) !important; z-index: 999999 !important; display: flex !important; justify-content: center !important; align-items: center !important;">
            <div class="loader-squares">
                <div class="loader-square"></div>
                <div class="loader-square"></div>
                <div class="loader-square"></div>
            </div>
        </div>`;

    jQuery("body").append(loaderHtml);

    // ✅ Open map (should be MUCH faster now)
    this.GLSDkWidget.openMap();
  }
}

jQuery(function () {
  if (typeof woocommerce_params != "undefined") {
    window.GLSDk = new GLSDk(woocommerce_params.ajax_url);
  }
});
